// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.reporting-filter .reporting-filter-options-container .each-option, .reporting-filter .reporting-filter-radio-group, .reporting-filter .reporting-filter-text-field, .reporting-filter {
  font-family: "72-Regular";
}

.reporting-filter {
  position: relative;
  display: inline-block;
  padding: 0 0.5rem 0.3rem;
  margin-right: 1rem;
  margin-bottom: 0.5rem;
  background-color: #ffffff;
  border: solid 0.1rem #7ecde8;
  cursor: pointer;
  color: #515559;
  font-size: 1.2rem;
  border-radius: 2px;
  height: 2.58rem;
}
.reporting-filter .multipleDropdownCls {
  display: inline-block;
  margin: 0 -1.2rem 0 -0.9rem;
}
.reporting-filter .multipleDropdownCls ss-multiselect-dropdown .dropdown-inline button.btn {
  color: #0a6ed1;
  border: none !important;
  outline: none !important;
  padding-left: 0.8rem;
  font-size: 1.3rem;
}
.reporting-filter .multipleDropdownCls ss-multiselect-dropdown .open > .dropdown-menu {
  min-width: 24rem !important;
  left: -6.25rem;
}
.reporting-filter .reporting-filter-text-field {
  vertical-align: middle;
  font-size: 1rem;
  letter-spacing: 0;
  text-align: left;
  color: #4a4a4a;
  display: inline-block;
  padding-top: 0.4rem;
}
.reporting-filter .reporting-filter-text-field .cald_filter-search-container {
  width: 20rem;
}
.reporting-filter .reporting-filter-text-field .cald_filter-search-container .side-margin-left {
  margin: 4px 0px !important;
  height: 1.6rem;
  padding: 0;
}
.reporting-filter .reporting-filter-text-field .cald_filter-search-container .side-margin-left input {
  top: 0;
}
.reporting-filter .reporting-filter-text-field .cald_filter-search-container .side-margin-left .clear-filter {
  top: 0 !important;
}
.reporting-filter .reporting-filter-text-field .cald_filter-search-container .search-members-container {
  left: 0rem;
  top: 2rem;
}
.reporting-filter .reporting-filter-text-field .filter-pattern {
  border-radius: 0.3rem;
  padding: 0 2.2rem 0 1.2rem !important;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  outline: none;
  font-size: 1.4rem;
  position: relative;
  top: 0.13rem;
  top: 0.5px;
  width: auto;
  height: 2rem;
}
.reporting-filter .reporting-filter-text-field .input-group {
  float: inline-end;
  bottom: 0.4rem;
}
.reporting-filter .reporting-filter-text-field .calendar-span {
  width: 1rem;
}
.reporting-filter .filter-name {
  text-transform: capitalize;
  margin-right: 0.5rem;
}
.reporting-filter .selected-filters {
  color: #0a6ed1;
  padding: 0 0.6rem 0 0.6rem;
  font-size: 1.4rem;
}
.reporting-filter .cc-caret-arrow {
  color: #0a6ed1;
  position: relative;
  top: 0.2rem;
  margin-left: 0.3rem;
}
.reporting-filter .close-icon {
  width: 1.2rem;
  height: 1.3rem;
  color: #0a6ed1;
  font-size: 1.2rem;
  margin-left: 0.8rem;
  position: relative;
  top: 0.2rem;
}
.reporting-filter .cald_filter-divider {
  border-left: solid 0.1rem #7ecde8;
  padding: 0rem 0.4rem 0.6rem 0.4rem;
}
.reporting-filter .reporting-filter-radio-group {
  font-size: 1.2rem;
  letter-spacing: 0;
  text-align: left;
  color: #4a4a4a;
}
.reporting-filter .reporting-filter-radio-group label {
  margin-right: 0.5rem;
  color: #0a6ed1;
  font-weight: normal;
  margin-bottom: 0;
}
.reporting-filter .reporting-filter-radio-group label input {
  position: relative;
  top: -0.3rem;
  margin-right: 0.3rem !important;
}
.reporting-filter .text-container {
  height: 2.68rem;
}
.reporting-filter .text-container .filterText {
  border: 0.1rem solid #9b9b9b;
  border-radius: 0.3rem;
  height: 1.6rem;
  width: inherit;
}
.reporting-filter .text-container .filterText.pattern-text {
  padding: 0 5px;
  border-left: 0;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  height: 2rem;
  position: relative;
}
.reporting-filter .reporting-filter-options-container {
  position: absolute;
  top: 100%;
  left: auto;
  right: 1rem;
  z-index: 1000;
  float: left;
  margin: 0.2rem 0 0;
  font-size: 1.4rem;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  max-width: max-content;
  min-width: 16rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(51, 51, 51, 0.2);
  border: solid 0.1rem #eeeeef;
  border-radius: 0.4rem;
}
.reporting-filter .reporting-filter-options-container ul {
  overflow-y: auto;
  max-height: 20rem;
  width: 100%;
}
.reporting-filter .reporting-filter-options-container ul li {
  list-style-type: none;
}
.reporting-filter .reporting-filter-options-container:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 0.1rem;
  right: 0;
  box-sizing: border-box;
  border: 0.6rem solid #fff;
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 0.2rem 0.2rem 0 rgba(51, 51, 51, 0.2);
}
.reporting-filter .reporting-filter-options-container .each-option {
  padding: 6px;
  font-size: 1.4rem;
  letter-spacing: 0;
  border-radius: 5px;
  margin: 5px 5px 0px 5px;
}
.reporting-filter .reporting-filter-options-container .each-option.each-option-selected {
  background-color: #eef5fc;
}
.reporting-filter .reporting-filter-options-container .each-option label input[type=checkbox] {
  position: relative;
  margin-right: 0.5rem !important;
}
.reporting-filter .reporting-filter-options-container .each-option label input[type=checkbox]:after {
  border-radius: 0.4rem;
}

.multipleDropdownCls .multiselect-dropdown .dropdown-btn {
  border: none !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.multipleDropdownCls .multiselect-dropdown .dropdown-btn .dropdown-multiselect__caret {
  height: 27px !important;
}

.multipleDropdownCls .dropdown-list {
  width: 200px !important;
  left: -44px !important;
}

.ag-checkbox-input-wrapper {
  top: -4px !important;
  margin-top: 1rem;
}

.toDatePosition {
  top: -4px !important;
  left: 6px !important;
  width: auto !important;
}

.toDateInputPosition {
  max-width: 172px !important;
}

.calendarSpanWidth {
  width: 3rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/filters/filters.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AADA;EACE,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,eAAA;AAGF;AADE;EAEE,qBAAA;EACA,2BAAA;AAEJ;AACQ;EACE,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,iBAAA;AACV;AAEM;EACE,2BAAA;EACA,cAAA;AAAR;AAKE;EACE,sBAAA;EACA,eAAA;EAEA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,YAAA;AAJN;AAMM;EACE,0BAAA;EACA,cAAA;EACA,UAAA;AAJR;AAMQ;EACE,MAAA;AAJV;AAOQ;EACE,iBAAA;AALV;AASM;EACE,UAAA;EACA,SAAA;AAPR;AAWI;EACE,qBAAA;EACA,qCAAA;EACA,6BAAA;EACA,0BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AATN;AAWI;EACE,iBAAA;EACA,cAAA;AATN;AAWI;EACE,WAAA;AATN;AAaE;EACE,0BAAA;EACA,oBAAA;AAXJ;AAcE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;AAZJ;AAeE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAdJ;AAiBE;EACE,iCAAA;EACA,kCAAA;AAfJ;AAkBE;EACE,iBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,cAAA;AAjBJ;AAmBI;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAjBN;AAmBM;EACE,kBAAA;EACA,YAAA;EACA,+BAAA;AAjBR;AAsBE;EACG,eAAA;AApBL;AAqBI;EACE,4BAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;AAnBN;AAsBM;EACE,cAAA;EACA,cAAA;EACA,4BAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AApBR;AAyBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EAEA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,4BAAA;EACA,sBAAA;EACA,gBAAA;EAYA,mDAAA;EACA,4BAAA;EACA,qBAAA;AAlCJ;AAsBI;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AApBN;AAqBM;EACG,qBAAA;AAnBT;AA4BI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;EACA,+CAAA;EAEA,qBAAA;EAEA,yBAAA;EACA,sDAAA;AA1BN;AA6BI;EAEE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AA5BN;AA8BM;EACE,yBAAA;AA5BR;AAgCQ;EACE,kBAAA;EACA,+BAAA;AA9BV;AAgCU;EACE,qBAAA;AA9BZ;;AAuCA;EACE,uBAAA;EACA,2BAAA;EACA,8BAAA;AApCF;;AAuCA;EACE,uBAAA;AApCF;;AAuCA;EACE,uBAAA;EACA,sBAAA;AApCF;;AAwCA;EACE,oBAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,oBAAA;EACA,oBAAA;EACA,sBAAA;AArCF;;AAwCA;EACE,2BAAA;AArCF;;AAuCA;EACE,sBAAA;AApCF","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n\n.reporting-filter {\n  position: relative;\n  display: inline-block;\n  padding: 0 0.5rem 0.3rem;\n  margin-right: 1rem;\n  margin-bottom: 0.5rem;\n  background-color: #ffffff;\n  border: solid 0.1rem #7ecde8;\n  cursor: pointer;\n  color: #515559;\n  font-size: 1.2rem;\n  @extend %font-regular;\n  border-radius: 2px;\n  height: 2.58rem;\n\n  .multipleDropdownCls{\n    // width: 10rem;\n    display: inline-block;\n    margin: 0 -1.2rem 0 -0.9rem;\n    ss-multiselect-dropdown {\n      .dropdown-inline{\n        button.btn{\n          color: #0a6ed1;\n          border: none !important;\n          outline: none !important;\n          padding-left: 0.8rem;\n          font-size: 1.3rem;\n        }\n      }\n      .open>.dropdown-menu {\n        min-width: 24rem !important;\n        left: -6.25rem;\n      }\n    }\n  }\n\n  .reporting-filter-text-field {\n    vertical-align: middle;\n    font-size: 1rem;\n    @extend %font-regular;\n    letter-spacing: 0;\n    text-align: left;\n    color: #4a4a4a;\n    display: inline-block;\n    padding-top: 0.4rem;\n\n    .cald_filter-search-container {\n      width: 20rem;\n\n      .side-margin-left {\n        margin: 4px 0px !important;\n        height: 1.6rem;\n        padding: 0;\n\n        input {\n          top: 0;\n        }\n\n        .clear-filter {\n          top: 0 !important;\n        }\n      }\n\n      .search-members-container {\n        left: 0rem;\n        top: 2rem;\n      }\n    }\n\n    .filter-pattern {\n      border-radius: 0.3rem;\n      padding: 0 2.2rem 0 1.2rem !important;\n      border-bottom-right-radius: 0;\n      border-top-right-radius: 0;\n      outline: none;\n      font-size: 1.4rem;\n      position: relative;\n      top: 0.13rem;\n      top: 0.5px;\n      width: auto;\n      height: 2rem;\n    }\n    .input-group{\n      float: inline-end;\n      bottom: 0.4rem;\n    }\n    .calendar-span{\n      width: 1rem;\n    }\n  }\n\n  .filter-name {\n    text-transform: capitalize;\n    margin-right: 0.5rem;\n  }\n\n  .selected-filters {\n    color: #0a6ed1;\n    padding: 0 0.6rem 0 0.6rem;\n    font-size: 1.4rem;\n  }\n\n  .cc-caret-arrow {\n    color: #0a6ed1;\n    position: relative;\n    top: 0.2rem;\n    margin-left: 0.3rem;\n  }\n\n  .close-icon {\n    width: 1.2rem;\n    height: 1.3rem;\n    color: #0a6ed1;\n    font-size: 1.2rem;\n    margin-left: 0.8rem;\n    position: relative;\n    top: 0.2rem;\n  }\n\n  .cald_filter-divider {\n    border-left: solid 0.1rem #7ecde8;\n    padding: 0rem 0.4rem 0.6rem 0.4rem;\n  }\n\n  .reporting-filter-radio-group {\n    font-size: 1.2rem;\n    @extend %font-regular;\n    letter-spacing: 0;\n    text-align: left;\n    color: #4a4a4a;\n\n    label {\n      margin-right: 0.5rem;\n      color: #0a6ed1;\n      font-weight: normal;\n      margin-bottom: 0;\n\n      input {\n        position: relative;\n        top: -0.3rem;\n        margin-right: 0.3rem !important;\n      }\n    }\n  }\n\n  .text-container {\n     height: 2.68rem;\n    .filterText {\n      border: 0.1rem solid #9b9b9b;\n      border-radius: 0.3rem;\n      height: 1.6rem;\n      width: inherit;\n      // padding-top: 0;\n\n      &.pattern-text {\n        padding: 0 5px;\n        border-left: 0;\n        border-bottom-left-radius: 0;\n        border-top-left-radius: 0;\n        height: 2rem;\n        position: relative;\n      }\n    }\n  }\n\n  .reporting-filter-options-container {\n    position: absolute;\n    top: 100%;\n    left: auto;\n    right: 1rem;\n    z-index: 1000;\n    float: left;\n    // padding: 1rem;\n    margin: 0.2rem 0 0;\n    font-size: 1.4rem;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    -webkit-background-clip: padding-box;\n    background-clip: padding-box;\n    max-width: max-content;\n    min-width: 16rem;\n\n    ul {\n      overflow-y: auto;\n      max-height: 20rem;\n      width: 100%;\n      li {\n         list-style-type: none;\n      }\n    }\n\n    -webkit-box-shadow: 0 0.2rem 0.4rem 0 rgba(51, 51, 51, 0.2);\n    box-shadow: 0 0.2rem 0.4rem 0 rgba(51, 51, 51, 0.2);\n    border: solid 0.1rem #eeeeef;\n    border-radius: 0.4rem;\n\n    &:before {\n      content: '';\n      position: absolute;\n      width: 0;\n      height: 0;\n      top: 0.1rem;\n      right: 0;\n      box-sizing: border-box;\n      border: 0.6rem solid #fff;\n      border-color: transparent transparent #fff #fff;\n      -webkit-transform-origin: 0 0;\n      transform-origin: 0 0;\n      -webkit-transform: rotate(135deg);\n      transform: rotate(135deg);\n      box-shadow: -1px 0.2rem 0.2rem 0 rgba(51, 51, 51, 0.2);\n    }\n\n    .each-option {\n      @extend %font-regular;\n      padding: 6px;\n      font-size: 1.4rem;\n      letter-spacing: 0;\n      border-radius: 5px;\n      margin: 5px 5px 0px 5px;\n\n      &.each-option-selected {\n        background-color: #eef5fc;\n      }\n\n      label {\n        input[type='checkbox'] {\n          position: relative;\n          margin-right: 0.5rem !important;\n\n          &:after {\n            border-radius: 0.4rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n.multipleDropdownCls .multiselect-dropdown .dropdown-btn{\n  border: none !important;\n  padding-top: 3px !important;\n  padding-bottom: 3px !important;\n}\n\n.multipleDropdownCls .multiselect-dropdown .dropdown-btn .dropdown-multiselect__caret{\n  height: 27px !important;\n}\n\n.multipleDropdownCls .dropdown-list{\n  width: 200px !important;\n  left: -44px !important;\n  // right: 5px !important;\n}\n\n.ag-checkbox-input-wrapper{\n  top: -4px !important;\n  margin-top:1rem;\n}\n\n.toDatePosition {\n  top: -4px !important;\n  left: 6px !important;\n  width: auto !important;\n  // max-width: 204px !important;\n}\n.toDateInputPosition {\n  max-width: 172px !important;\n}\n.calendarSpanWidth{\n  width: 3rem !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
